/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface ProfileMeDataSettings
 *
 */
// create custom validators for the regexes
export interface ProfileMeDataSettings {
    [key: string]: any | any;
    /**
     * Which locale does the user prefer
     * #type string
     * #memberof ProfileMeDataSettings
        
        
         */
    locale?: string;
    /**
     * Which format for dates does the user prefer
     * #type string
     * #memberof ProfileMeDataSettings
        
        
         */
    dateFormat?: string;
    /**
     * Which format for numbers does the user prefer
     * #type string
     * #memberof ProfileMeDataSettings
        
        
         */
    numberFormat?: string;
}
/**
 * Check if a given object implements the ProfileMeDataSettings interface.
 */
export function instanceOfProfileMeDataSettings(value: object): boolean {
    let isInstance = true;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const ProfileMeDataSettingsTypiaAssertEquals = (input: any) => {
    return ((input: any): ProfileMeDataSettings => {
        const __is = (input: any, _exceptionable: boolean = true): input is ProfileMeDataSettings => {
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => (undefined === input.locale || "string" === typeof input.locale) && (undefined === input.dateFormat || "string" === typeof input.dateFormat) && (undefined === input.numberFormat || "string" === typeof input.numberFormat) && Object.keys(input).every((key: any) => {
                if (["locale", "dateFormat", "numberFormat"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return false;
            });
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is ProfileMeDataSettings => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.locale || "string" === typeof input.locale || $guard(_exceptionable, {
                    path: _path + ".locale",
                    expected: "(string | undefined)",
                    value: input.locale
                })) && (undefined === input.dateFormat || "string" === typeof input.dateFormat || $guard(_exceptionable, {
                    path: _path + ".dateFormat",
                    expected: "(string | undefined)",
                    value: input.dateFormat
                })) && (undefined === input.numberFormat || "string" === typeof input.numberFormat || $guard(_exceptionable, {
                    path: _path + ".numberFormat",
                    expected: "(string | undefined)",
                    value: input.numberFormat
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["locale", "dateFormat", "numberFormat"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "ProfileMeDataSettings",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "ProfileMeDataSettings",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const ProfileMeDataSettingsTypiaAssertStringify = (input: ProfileMeDataSettings): string => {
    return ((input: any): string => { const assert = (input: any): ProfileMeDataSettings => {
        const __is = (input: any): input is ProfileMeDataSettings => {
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => (undefined === input.locale || "string" === typeof input.locale) && (undefined === input.dateFormat || "string" === typeof input.dateFormat) && (undefined === input.numberFormat || "string" === typeof input.numberFormat) && Object.keys(input).every((key: any) => {
                if (["locale", "dateFormat", "numberFormat"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/(.*)/).test(key))
                    return true;
                return true;
            });
            return "object" === typeof input && null !== input && false === Array.isArray(input) && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is ProfileMeDataSettings => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => (undefined === input.locale || "string" === typeof input.locale || $guard(_exceptionable, {
                    path: _path + ".locale",
                    expected: "(string | undefined)",
                    value: input.locale
                })) && (undefined === input.dateFormat || "string" === typeof input.dateFormat || $guard(_exceptionable, {
                    path: _path + ".dateFormat",
                    expected: "(string | undefined)",
                    value: input.dateFormat
                })) && (undefined === input.numberFormat || "string" === typeof input.numberFormat || $guard(_exceptionable, {
                    path: _path + ".numberFormat",
                    expected: "(string | undefined)",
                    value: input.numberFormat
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["locale", "dateFormat", "numberFormat"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/(.*)/).test(key))
                        return true;
                    return true;
                }));
                return ("object" === typeof input && null !== input && false === Array.isArray(input) || $guard(true, {
                    path: _path + "",
                    expected: "ProfileMeDataSettings",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "ProfileMeDataSettings",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: ProfileMeDataSettings): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $so0 = (input: any): any => `{${$tail(`${undefined === input.locale ? "" : `"locale":${undefined !== input.locale ? $string(input.locale) : undefined},`}${undefined === input.dateFormat ? "" : `"dateFormat":${undefined !== input.dateFormat ? $string(input.dateFormat) : undefined},`}${undefined === input.numberFormat ? "" : `"numberFormat":${undefined !== input.numberFormat ? $string(input.numberFormat) : undefined},`}${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["locale", "dateFormat", "numberFormat"].some((regular: any) => regular === key))
            return ""; return `${JSON.stringify(key)}:${undefined !== value ? JSON.stringify(value) : undefined}`; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const ProfileMeDataSettingsValidatorShape = {
    'locale': yup.string(),
    'dateFormat': yup.string(),
    'numberFormat': yup.string(),
};
export const ProfileMeDataSettingsValidator = yup.mixed().transform((val: any) => { return val instanceof Object && !Array.isArray(val) ? val : {}; });
export const ProfileMeDataSettingsStringifyShapeProperties: ObjectSchema['properties'] = {
    'locale': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'dateFormat': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
    'numberFormat': {
        'type': 'string',
    } as unknown as fastJSON.StringSchema,
};
export const ProfileMeDataSettingsStringifyShape: ObjectSchema = {
    title: 'ProfileMeDataSettings Stringifier',
    type: 'object',
    properties: {
        ...ProfileMeDataSettingsStringifyShapeProperties
    },
    required: [],
    additionalProperties: true
};
export const ProfileMeDataSettingsStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(ProfileMeDataSettingsStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const ProfileMeDataSettingsStringify: (data: ProfileMeDataSettings) => string = ProfileMeDataSettingsStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function ProfileMeDataSettingsFromJSON(json: any): ProfileMeDataSettings {
    return ProfileMeDataSettingsFromJSONTyped(json, false);
}
export function ProfileMeDataSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileMeDataSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        ...json,
        'locale': !exists(json, 'locale') ? undefined : json['locale'],
        'dateFormat': !exists(json, 'dateFormat') ? undefined : json['dateFormat'],
        'numberFormat': !exists(json, 'numberFormat') ? undefined : json['numberFormat'],
    };
}
export function ProfileMeDataSettingsToJSON(value?: ProfileMeDataSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...value,
        'locale': value.locale,
        'dateFormat': value.dateFormat,
        'numberFormat': value.numberFormat,
    };
}
